<nb-card *ngIf="isOpen">
  
  <nb-card-header class="d-flex align-items-center">
    <morva-icons 
      nbTooltip="عدم نمایش پنجره"
      class="close-cross cursor-pointer icon-16" 
      icon="remove"
      (click)="closeModal()">
    </morva-icons>
    <span class="text">بارگذاری منبع داده</span>
  </nb-card-header>
  
  <nb-card-body>
    <div class="content-scrollable">
      <div *ngFor="let item of items; index as i">
        <div class="card-container">
          <div *ngIf="!item.isDuplicated" class="title-box d-flex justify-content-between">
            <p 
              *ngIf="0 <= item.completionPercentage && item.completionPercentage < 100 && !item.hasError" 
              class="mb-0 text" 
              [class]="item.isExpanded ? 'w-100' : 'w-60'">
                {{ (item.isUpdatingProcess)? 'به‌روز‌رسانی منبع داده' : 'بارگذاری منبع داده' }} “{{ item.dataSourceName }}“
            </p>

            <div 
              class="d-flex gap-1" 
              *ngIf="item.completionPercentage == 100" 
              [class]="item.isExpanded ? 'w-100' : 'w-60'">
              <morva-icons class="close-cross cursor-pointer icon-20" icon="successCheck"></morva-icons>
              <p class="mb-0 text">
                {{ (item.isUpdatingProcess)? 'به‌روز‌رسانی منبع داده' : 'بارگذاری منبع داده' }} “{{ item.dataSourceName }}“ با موفقیت انجام شد.
              </p>
            </div>

            <div 
              class="d-flex gap-1" 
              *ngIf="item.hasError" 
              [class]="item.isExpanded ? 'w-100' : 'w-60'">
              <morva-icons class="close-cross cursor-pointer icon-20" icon="failCheck"></morva-icons>
              <p class="mb-0 text">
                {{ (item.isUpdatingProcess)? 'به‌روز‌رسانی منبع داده' : 'بارگذاری منبع داده' }} “{{ item.dataSourceName }}“ انجام نشد. پس از بررسی جدول، دوباره امتحان کنید.
              </p>
            </div>

            <div class="d-flex justify-content-center gap-2">

              <!-- 
                <p *ngIf="!item.isExpanded && item.progressStatus == 'InProgress'" class="time-text d-flex m-0">
                  {{ item.processCompletionTime | secondsToTime | persianNumber }} تا پایان
                </p> 
              -->
              <ng-container *ngIf="item.hasError || item.completionPercentage == 100; else showToggleIcon">
                <morva-icons 
                  class="float-end icon-12 cursor-pointer mt-1"
                  icon="close"
                  (click)="closeItem(i)">
                </morva-icons>
              </ng-container>
              <ng-template #showToggleIcon>
                <morva-icons 
                  class="float-end icon-12 cursor-pointer mt-1"
                  [icon]="item.isExpanded ? 'caretUpOutline' : 'caretDownOutline'"
                  (click)="toggleItem(i)">
                </morva-icons>
              </ng-template>
              
            </div>
          </div>
          <!-- <div *ngIf="item.isDuplicated"  class="title-box d-flex justify-content-between align-items-center">
            <p *ngIf="item.progressStatus == 'InProgress'" class="mb-0 text" [class]="item.progressStatus == 'Completed' || item.isExpanded ? 'w-100' : 'w-60'">
              کپی منبع داده “{{ item.name }}“
            </p>

            <div class="d-flex gap-1" *ngIf="item.progressStatus == 'Completed'" [class]="item.progressStatus == 'Completed' || item.isExpanded ? 'w-100' : 'w-60'">
              <morva-icons class="close-cross cursor-pointer icon-20" icon="successCheck"></morva-icons>
              <p class="mb-0 text">
                کپی منبع داده “{{ item.name }}“ با موفقیت انجام شد.
              </p>
            </div>
            <div class="d-flex justify-content-center align-items-center gap-2">
              <p *ngIf="!item.isExpanded && item.progressStatus == 'InProgress'" class="time-text d-flex m-0">{{ item.processCompletionTime | secondsToTime | persianNumber }} تا پایان</p>
            <morva-icons (click)="toggleItem(i)" [icon]="item.isExpanded ? 'caretUpOutline' : 'caretDownOutline'"
              class="float-end icon-12 cursor-pointer mt-1">
              ></morva-icons>
            </div>
          </div> -->
          
          <div *ngIf="item.isExpanded">
            <div class="card-body p-0 pt-3">
              <!-- 
                <p *ngIf="item.processCompletionTime != 0" class="text">زمان تقریبی اتمام بارگذاری: {{ item.processCompletionTime | secondsToTime | persianNumber }}</p>
                <p *ngIf="item.processCompletionTime == 0" class="text">زمان تقریبی اتمام بارگذاری: ۰ ثانیه</p> 
              -->
              <div class="progress-container d-flex gap-2">
                
                <button 
                  *ngIf="item.completionPercentage < 100 && !item.isUpdatingProcess" 
                  class="cancel-progress-button icon-16" 
                  (click)="cancelUploadProgress(item)">
                  <morva-icons class="cancel-upload-progress" icon="close"></morva-icons>
                </button>
                
                <p *ngIf="!item.needRetry" class="percentage-text m-0 d-flex">
                   ٪{{item.completionPercentage | number : '1.2-2' | persianNumber}}
                </p>
                <!-- Faded Percentage and Reload Icon for HasError -->
                <p *ngIf="item.needRetry" class="percentage-text m-0 d-flex">
                  <span class="faded-text">
                    ٪{{item.completionPercentage | persianNumber}}
                  </span>
                  <morva-icons (click)="onRetryDataSource(item)" class="cursor-pointer reload-icon" icon="blueReload"></morva-icons>
                </p>                
                <div class="progress">
                  <!--[ngClass]="{'has-error': item.needRetry || item.progressStatus == 'HasError'}"-->
                  <div 
                    class="progress-bar"
                    [class.has-error]="item.hasError"
                    role="progressbar" 
                    [aria-valuenow]="item.completionPercentage" 
                    aria-valuemin="0" 
                    aria-valuemax="100" 
                    [style.width]="item.completionPercentage + '%'">
                  </div>
                </div>
              </div>

                      <!-- <div *ngIf="item.errorMessages?.length > 0" class="red-box">
                        <div class="blue-box-header">
                          <div>
                            <p class="red-text">موارد خطا ({{ item.errorMessages.length | persianNumber }})</p>
                          </div>
                          <div class="d-flex justify-content-center align-items-center gap-2 ">
                            <p *ngIf="!item?.isRedBoxExpanded" class="red-text">بیشتر</p>
                            <p *ngIf="item?.isRedBoxExpanded" class="red-text">کمتر</p>
                            <morva-icons (click)="toggleRedError(i)" [icon]="item?.isRedBoxExpanded ? 'caretUpOutline' : 'caretDownOutline'"
                              class="float-end icon-12 cursor-pointer mt-1">
                              ></morva-icons>
                          </div>
                        </div>
                        <div *ngIf="item?.isRedBoxExpanded" class=" red-box-body">
                          <div class="red-box-inside-body">
                            <div *ngFor="let error of item.errorMessages" class="d-flex">
                              <morva-icons icon="closeCircleRed"></morva-icons> <span class="red-text">{{ error }}</span>
                            </div>
                            </div>
                        </div>
                      </div> -->

            </div>
          </div>
        </div>
        <div class="seperator-line"></div>
      </div>
    </div>

    <div class="blue-box">
      <div class="blue-box-header">
        <div>
          <p class="text">اطلاعات</p>
        </div>
        <div class="d-flex justify-content-center align-items-center gap-2">
          <p *ngIf="!isBlueBoxOpen" class="text">بیشتر</p>
          <p *ngIf="isBlueBoxOpen" class="text">کمتر</p>
          <morva-icons (click)="toggleData()" [icon]="isBlueBoxOpen ? 'caretUpOutline' : 'caretDownOutline'"
            class="float-end icon-12 cursor-pointer mt-1">
            ></morva-icons>
        </div>
      </div>
      <div *ngIf="isBlueBoxOpen" class="list">
        <ul>
          <li class="text">
            ۱۰۰۰ رکورد اولیه بارگذاری شده‌ و آماده استفاده هستند.
          </li>
          <li class="text">داده‌ها به‌صورت تدریجی در حال اضافه شدن هستند.</li>
          <li class="text">
            فرآیند بارگذاری از طریق نوار پیشرفت قابل مشاهده است.
          </li>
        </ul>
      </div>
    </div>

  </nb-card-body>
</nb-card>